module.exports = __webpack_public_path__ + "img/815C41_F6C99A_D39F77_BB9474-256px.efb5d4f1.png";